import { useEffect, lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import FixedContactActions from './components/FixedContactActions';
import CmsPageLoader from './components/CmsPageLoader';
import Hero from './components/Hero';

// Lazy load page components to split JS and CSS bundles
const About = lazy(() => import('./components/About'));
const WhatWeDo = lazy(() => import('./components/WhatDo'));
const WhoWeServe = lazy(() => import('./components/WhoWeServe'));
const WhoWeEmpower = lazy(() => import('./components/WhoWeEmpower'));
const Student = lazy(() => import('./components/WhoWeEmpower/Student'));
const GraduatesAndJobSeekers = lazy(() => import('./components/WhoWeEmpower/Graduates&JobSeekers'));
const EngineersAndProfessionals = lazy(() => import('./components/WhoWeEmpower/Engineers&Professionals'));
const IndependentEngineers = lazy(() => import('./components/WhoWeEmpower/IndependentEngineers'));
const EducationalInstitutions = lazy(() => import('./components/WhoWeEmpower/Educational_Institutions'));
const IndustryAndEmployers = lazy(() => import('./components/WhoWeEmpower/Industry&Employers'));
const MentorsAndExperts = lazy(() => import('./components/WhoWeEmpower/Mentor&Experts'));
const Partnerships = lazy(() => import('./components/Partnerships'));
const Collaborate = lazy(() => import('./components/Collaboration'));
const Program = lazy(() => import('./pages/Program'));
const EngineeringSkillDevelopment = lazy(() => import('./pages/Program/EngineeringSkillDevelopment'));
const CareerGuidanceEmployability = lazy(() => import('./pages/Program/CareerGuidanceEmployability'));
const IndependentEngineer = lazy(() => import('./pages/Program/IndependentEngineer'));
const EngineerWelfareRecognition = lazy(() => import('./pages/Program/EngineerWelfareRecognition'));
const IndustryAcademiaCollaboration = lazy(() => import('./pages/Program/IndustryAcademiaCollaboration'));
const TechnologyInnovationDevelopment = lazy(() => import('./pages/Program/TechnologyInnovationDevelopment'));
const EngineeringCommunityDevelopment = lazy(() => import('./pages/Program/EngineeringCommunityDevelopment'));
const IndiaEngineeringGrowthMission = lazy(() => import('./pages/Program/IndiaEngineeringGrowthMission'));
const Login = lazy(() => import('./pages/Login'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const EditHomePage = lazy(() => import('./pages/admin/EditHomePage'));
const EditCmsPage = lazy(() => import('./pages/admin/EditCmsPage'));
const Partnership1 = lazy(() => import('./components/Partnership1'));
const ContactUs = lazy(() => import('./pages/ContactUs'));

function App() {
  const { pathname } = useLocation();
  const isCmsShell = pathname === '/login' || pathname.startsWith('/admin');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      {!isCmsShell && <Nav />}
      <main id="main-content">
        <Suspense fallback={<CmsPageLoader label="Loading page..." />}>
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/about" element={<About />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/who-we-empower" element={<WhoWeEmpower />} />
            <Route path="/who-we-empower/student" element={<Student />} />
            <Route path="/who-we-empower/graduates-job-seekers" element={<GraduatesAndJobSeekers />} />
            <Route path="/who-we-empower/engineers-professionals" element={<EngineersAndProfessionals />} />
            <Route path="/who-we-empower/independent-engineers" element={<IndependentEngineers />} />
            <Route path="/who-we-empower/educational-institutions" element={<EducationalInstitutions />} />
            <Route path="/who-we-empower/industry-employers" element={<IndustryAndEmployers />} />
            <Route path="/who-we-empower/mentors-experts" element={<MentorsAndExperts />} />
            <Route path="/partnership" element={<Partnership1 />} />
            <Route path="/partnership1" element={<Partnership1 />} />
            <Route path="/partnerships1" element={<Navigate to="/partnership" replace />} />
            <Route path="/partner-form" element={<Navigate to="/contact-us" replace />} />
            <Route path="/programs" element={<Program />} />
            <Route path="/program" element={<Navigate to="/programs" replace />} />
            <Route path="/programs/engineering-skill-development" element={<EngineeringSkillDevelopment />} />
            <Route path="/programs/career-guidance-employability" element={<CareerGuidanceEmployability />} />
            <Route path="/programs/independent-engineer" element={<IndependentEngineer />} />
            <Route path="/programs/engineer-welfare-recognition" element={<EngineerWelfareRecognition />} />
            <Route path="/programs/industry-academia-collaboration" element={<IndustryAcademiaCollaboration />} />
            <Route path="/programs/technology-innovation-development" element={<TechnologyInnovationDevelopment />} />
            <Route path="/programs/engineering-community-development" element={<EngineeringCommunityDevelopment />} />
            <Route path="/programs/india-engineering-growth-mission" element={<IndiaEngineeringGrowthMission />} />
            <Route path="/collaborate" element={<Navigate to="/partnership" replace />} />
            <Route path="/partnerships" element={<Navigate to="/contact-us" replace />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/contact" element={<Navigate to="/contact-us" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="pages/home" element={<EditHomePage />} />
              <Route path="pages/:pageKey" element={<EditCmsPage />} />
            </Route>
          </Routes>
        </Suspense>
      </main>
      {!isCmsShell && <FixedContactActions />}
      {!isCmsShell && (
        <Footer tightTop={pathname === '/partner-form' || pathname === '/about' || pathname === '/contact-us' || pathname === '/contact'} />
      )}
    </>
  );
}

export default App;
